import React from "react";
import ExperienceCard from "./experienceCard";
import dummylogo from "../../assests/dummylogo.png"

export default function Experience(props){
    
    const employees = [
        {
          image:dummylogo,
          name: "John Doe",
          designation: "Software Engineer",
          dateOfJoining: "2022-01-01",
          dateOfResignation: "2023-01-01",
        },
        {
          image: dummylogo,
          name: "Jane Smith",
          designation: "Product Manager",
          dateOfJoining: "2020-05-15",
          dateOfResignation: "2021-06-30",
        },
        {
            image:dummylogo,
            name: "John Doe",
            designation: "Software Engineer",
            dateOfJoining: "2022-01-01",
            dateOfResignation: "2023-01-01",
          },
        // Add more employee data as needed
      ];
    return (
        <div className="px-6 py-6 border-t">
        {props.exp.map((employee, index) => (
          <ExperienceCard key={index} {...employee} />
        ))}
      </div>
    );
}